<template>
  <div class="user-select-none position-absolute w-100 report-nav-container" :class="{ open: isOpen, navigating }">
    <div class="w-100 d-flex justify-content-center align-items-center report-nav"
         :class="[ isFixed ? 'position-fixed' : 'position-relative' ]">
      <a class="adobe-clean-black cursor-pointer title" href="#" @click.prevent="open">
        <transition name="title" mode="out-in">
          <span class="d-block" :key="isOpen">

            {{ isOpen ? 'Close' : 'Mobile Study 2018' }}

            <svg :style="[ isOpen ? { transform: 'rotate(-180deg)' } : { transform: 'rotate(0deg)' } ]" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            	 viewBox="0 0 8.8 4.4" style="enable-background:new 0 0 8.8 4.4;" xml:space="preserve" width="10px" height="10px">
              <polygon class="st0" points="8.8,0 4.4,4.4 0,0 "/>
            </svg>

          </span>
        </transition>
      </a>
    </div>
    <div class="w-100 h-100 position-fixed d-flex justify-content-center align-items-center flex-column nav-content"
         :class="[ isOpen ? 'pointer-events-auto' : 'pointer-events-none' ]">
      <div class="position-absolute w-100 h-100 wipe"
           :style="{ background: 'linear-gradient( -15deg, ' + mainColor + ', ' + accent + ')' }"></div>
      <div class="links">
        <ul class="p-0 m-0">
          <li class="text-center" v-for="(link, index) in links">
            <a href="#" class="d-inline-block" :class="{ active: ($route.path === '/report/' + index) }"
               @click.prevent="delayedClose('/report/' + index)">
              {{ link }}
              <span class="position-absolute w-100 line"
                    :style="{ background: 'linear-gradient( to right, ' + accent + ', ' + mainColor + ')' }"></span>
            </a>
          </li>
        </ul>
      </div>
      <div class="personalize" v-if="demoCapable">
        <p class="text-center">Personalize Your Report</p>
        <div class="d-flex justify-content-center icons">
          <router-link to="/demos/motion" class="d-flex justify-content-center align-items-center"
                       @click.native="enableScroll">
            <MotionIcon :white="true" :complete="demo1Complete" :active="iconActive" :isButton="true"></MotionIcon>
          </router-link>
          <router-link to="/demos/scroll" class="d-flex justify-content-center align-items-center"
                       @click.native="enableScroll">
            <ScrollIcon :white="true" :complete="demo2Complete" :active="iconActive" :isButton="true"></ScrollIcon>
          </router-link>
          <router-link to="/demos/terrain" class="d-flex justify-content-center align-items-center"
                       @click.native="enableScroll">
            <ArIcon :white="true" :complete="demo3Complete" :active="iconActive" :isButton="true"></ArIcon>
          </router-link>
        </div>
      </div>
      <div class="position-absolute toggles">
        <div class="report-type" :class="{ right: (industry !== 'mktg') }" @click="toggle('industry')">
          <p>Marketer</p>
          <div class="button"></div>
          <p>IT</p>
        </div>
        <div class="report-length" :class="{ right: ($store.state.report.length === reportLengths.long) }" @click="toggle('length')">
          <p>Short</p>
          <div class="button"></div>
          <p>Long</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { TweenMax } from 'gsap'
  import 'ScrollToPlugin'
  import { mapState } from 'vuex'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import { reportLengths, gnavHeightMobile } from '@/lib/consts'
  import MotionIcon from '@/components/svg/MotionIcon'
  import ScrollIcon from '@/components/svg/ScrollIcon'
  import ArIcon from '@/components/svg/ArIcon'

  export default {
    name: 'NavBar',
    mixins: [ StateMixin ],
    components: {
      MotionIcon, ScrollIcon, ArIcon
    },
    data () {
      return {
        isFixed: false,
        iconActive: false,
        isOpen: false,
        navigating: false,
        links: [
          'Introduction',
          'Strategize',
          'Build',
          'Acquire',
          'Analyze',
          'Engage',
          'Optimize',
          'Conclusion'
        ]
      }
    },
    computed: {
      reportLengths () {
        return reportLengths
      },
      ...mapState( 'demo1', {
        demo1Complete: state => state.complete
      } ),
      ...mapState( 'demo2', {
        demo2Complete: state => state.complete
      } ),
      ...mapState( 'demo3', {
        demo3Complete: state => state.complete
      } )
    },
    methods: {
      open () {
        if ( this.isOpen ) {
          this.iconActive = false
          this.isOpen = false
          this.enableScroll()
        } else {
          this.iconActive = true
          this.isOpen = true
          if ( !this.isFixed ) {
            TweenMax.to( window, 0.5, {
              scrollTo: { y: gnavHeightMobile + 1, autoKill: false },
              onComplete () {
                document.body.style.overflow = 'hidden' // prevent scrolling while nav is open
              }
            } )
          } else {
            document.body.style.overflow = 'hidden' // prevent scrolling while nav is open
          }
        }
      },
      enableScroll () {
        document.body.style.overflow = 'auto' // add scrolling ability back when nav is closed
      },
      delayedClose ( path ) {
        this.navigating = true
        window.scrollTo( 0, 0 ) // start at the top of the page
        this.enableScroll()

        this.$nextTick( () => {
          setTimeout( () => {
            this.$router.push( path )
            this.isOpen = this.navigating = false
          }, 400 )
        } )
      },
      toggle ( el ) {
        switch ( el ) {
          case 'industry':
            this.$store.dispatch( 'setIndustry', this.industry === 'mktg' ? 'it' : 'mktg' )
            break
          case 'length':
            this.$store.dispatch( 'setReportLength', this.$store.state.report.length === reportLengths.short ? reportLengths.long : reportLengths.short )
            break
          default:
        }
      }
    },
    mounted () {
      /* eslint-disable no-new */
      new window.Waypoint( {
        element: this.$el,
        handler: dir => {
          this.isFixed = (dir === 'down')
        }
      } )
    },
    beforeDestroy () {
      this.iconActive = false
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../assets/scss/global/the_goods";

  $linksNum : 8;
  $wipeAni : 1s;
  $wipeDur : $wipeAni / 2;
  $bez : cubic-bezier(0.1, .9, .2, 1);

  .report-nav-container {
    opacity    : 0;
    transition : opacity 0.3s;
    z-index    : 50;
    left       : 0;
    top        : $gnavHeightMobile;

    .report-nav {
      height                : 45px;
      top                   : 0;
      left                  : 0;
      background            : rgba(0, 0, 0, 0.8);
      z-index               : 49;
      background-blend-mode : multiply;

      a.title {
        color           : $white;
        text-decoration : none;
      }

      svg .st0 {
        fill : #fff;
      }
    }

    .links, .personalize, .report-type, .report-length {
      transition : opacity 0.4s;
    }

    &.navigating {
      .links, .personalize, .report-type, .report-length {
        opacity : 0.5;
      }
    }

    .nav-content {
      top     : 0;
      left    : 0;
      z-index : 48;

      .wipe {
        top                 : 0;
        left                : 0;
        transform           : translateY(-100%);
        transition          : transform 0s $wipeAni, opacity .5s;
        backface-visibility : hidden;
        opacity             : 0;
      }

      .links ul li {
        list-style : none;
        padding    : 6px 0;

        a {
          color            : $white;
          font-size        : 19px;
          text-decoration  : none;
          transform        : translateY(-10px);
          transition       : transform .2s, opacity .2s;
          opacity          : 0;
          padding-bottom   : 4px;
          transition-delay : 0s;

          span.line {
            height           : 2px;
            bottom           : 0;
            left             : 0;
            transform        : scaleX(0);
            transition       : transform .3s;
            transform-origin : 100% 50%;
          }

          &.active span.line {
            transform-origin : 0 50%;
            transform        : scaleX(1);
          }
        }
      }

      .toggles {
        bottom           : 0;
        opacity          : 0;
        height           : 45px;
        transition-delay : 0s;
        transition       : opacity .2s;
      }

      .personalize {
        p {
          color            : #FAFAFA;
          opacity          : 0;
          font-size        : 13px;
          margin-bottom    : 17px;
          transition       : opacity .2s;
          transition-delay : 0s;
        }

        .icons a {
          margin           : 0 25px;
          background       : rgba(216, 216, 216, 0.2);
          width            : 60px;
          height           : 60px;
          border-radius    : 50%;
          opacity          : 0;
          transform        : translateY(-15px);
          transition       : opacity .2s, transform .7s;
          transition-delay : 0s;

          svg {
            height : 85%;

            &.motion-icon g path {
              color : $white;
            }
          }
        }
      }
    }

    &.open .nav-content {
      .wipe {
        opacity    : 1;
        transform  : translateY(0%);
        transition : transform $bez $wipeAni, opacity 0s;
      }

      .links ul li {
        a {
          transform  : translateY(0px);
          opacity    : 1;
          transition : transform .5s, opacity .5s;
        }

        @for $i from 1 through $linksNum {
          &:nth-child(#{$i}) a {
            transition-delay : ($i * 20ms) + $wipeDur;
          }
        }
      }

      .personalize {
        p {
          opacity          : .5;
          transition       : opacity .9s;
          transition-delay : $wipeDur;
        }

        .icons a {
          opacity    : 1;
          transform  : translateY(0px);
          transition : opacity .9s, transform .7s;

          @for $i from 1 through 3 {
            &:nth-child(#{$i}) {
              transition-delay : ($i * 100ms) + $wipeDur;
            }
          }
        }
      }

      .toggles {
        opacity          : 1;
        transition       : opacity .5s;
        transition-delay : $wipeAni;
      }
    }
  }

  .title-enter,
  .title-leave-to {
    opacity : 0;
  }

  .title-enter {
    transform : translateY(-5px);
  }

  .title-leave-to {
    transform : translateY(5px);
  }

  .title-enter-to,
  .title-leave {
    opacity   : 1;
    transform : translateY(0px);
  }

  .title-enter-active,
  .title-leave-active {
    transition : opacity .3s, transform .3s;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/NavBar.vue